import type { FaireThemeEntity } from "../../entity_types/theme";

export const cozy_baby_knits_organic_wooly: FaireThemeEntity = {
  token: "cozy-baby-knits-organic-wooly",
  type: "theme",
  name: "Cozy Baby Knits (Organic & Wooly)",
  description: "",
  teaser: "",
  detail: "",
  bgColor: "#F5E6C8",
  exactProducts: true,
  retailerToken: "r_eer7xgiweo",
  productTokens: [
    "p_ubtu48y4tn",
    "p_9knaujwjm2",
    "p_4sgyrxzevs",
    "p_9sj2gkmu23",
    "p_7gxxwh45jk",
    "p_z5byx2z2t8",
    "p_9c8fhy9kp3",
    "p_7xnqf8b8a5",
    "p_6u2zz7z67y",
    "p_vkdf6v6cwd",
    "p_hu4vcpjcbz",
    "p_dskbf887qw",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
